export const APP_HOME_MENU_KEY = Symbol('appHomeMenuKey')
